<template>
  <v-card>
    <v-card-title class="primary white--text py-0" style="height: 52px;">
      <span class="title" style="line-height: 52px">{{ $tc('texts.product', 1) }}</span>
      <v-spacer/>
      <v-btn
        v-if="subscription.additional_companies_addable"
        small light color="white"
        @click="showAddAdditionalCompanyDialog({
          company_id: subscriptionGroup.company_id,
          subscription_id: subscription.subscription_id,
          additional_companies_addable: subscription.additional_companies_addable,
          interval: subscription.items[0].interval,
        })"
      >
        {{ $t('texts.addAddon') }}
        <v-icon right>
          add
        </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        hide-default-header
        :items="formattedItems"
        item-key="stripe_plan_id"
        :single-expand="singleExpand"
        :expanded.sync="expanded"
        show-expand
        hide-default-footer
      >
        <template v-slot:item.data-table-expand="{ item, expand, isExpanded }">
          <v-icon
            v-if="item.type === 'additional'"
            class="mr-2"
            @click="expand(!isExpanded)"
          >
            business
          </v-icon>
        </template>
        <template v-slot:expanded-item="{ item }">
          <td :colspan="headers.length" class="pa-0">
            <additional-companies-datatable
              :companies="item.companies"
              :subscriptionId="subscription.subscription_id"
              :subscriptionCompanyId="subscriptionGroup.company_id"
              :isCurrentlyCancellable="isCurrentlyCancellable"
              :showCancelSubscriptionDialog="showCancelSubscriptionDialog"
              :nextPossibleCancellationDate="subscription.next_possible_cancellation_date"
            />
          </td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import AdditionalCompaniesDatatable from './AdditionalCompaniesDatatable.vue';

export default {
  name: 'SubscriptionItem',
  components: {
    AdditionalCompaniesDatatable,
  },
  props: {
    subscriptionGroup: {
      type: Object,
    },
    language: {
      type: String,
    },
    isCurrentlyCancellable: {
      type: Boolean,
      default: false,
    },
    showAddAdditionalCompanyDialog: {
      type: Function,
      default: () => {},
    },
    showCancelSubscriptionDialog: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      expanded: [],
      singleExpand: true,
      headers: [
        { text: 'Name', value: 'formattedType', sortable: true },
        { text: this.$i18n.t('texts.count'), value: 'formattedQuantity', sortable: false },
        { text: this.$i18n.t('texts.price'), value: 'formattedPrice', sortable: false },
        { text: 'Info', value: 'info', sortable: false },
        { text: '', value: 'data-table-expand', sortable: false },
      ],
      pagination: {
        sortBy: 'type',
      },
    };
  },
  created() {
    this.pagination.descending = !this.pagination.descending;
  },
  computed: {
    subscription() {
      return this.subscriptionGroup.subscriptions[0];
    },
    formattedItems() {
      if (this.subscription.items.length > 0) {
        return this.subscription.items.map((item) => {
          const baseType = `${this.$i18n.t('texts.mainSubscriptionShort')} ${this.$i18n.t('texts.category')}`;
          const formattedType = item.type === 'base' ? baseType : item.translations.name[this.language];
          const formattedQuantity = `${this.$i18n.t('texts.count')}: ${item.quantity}`;
          const formattedPrice = `CHF ${this.pricePerProduct(item.quantity, item.amount)}`;
          const formattedItem = {
            ...item,
            formattedType,
            formattedQuantity,
            formattedPrice,
          };
          return formattedItem;
        });
      }
      return [];
    },
  },
  methods: {
    pricePerProduct(quantity, amount) {
      const result = parseInt(quantity, 10) * parseFloat(amount);
      return result.toFixed(2);
    },
  },
};
</script>
